module.exports = __webpack_public_path__ + "img/dsci0072.dad9331c.jpg";